import {Link} from "react-router-dom";
import styled from "styled-components";

export const Container = styled.div`
  padding: 1rem;
  overflow-y: auto;
  position: relative;
  overflow-x: hidden;
  transition: all ease 0.3s;
  background-color: ${({theme}) => theme["container"]};
  border-right: 1px solid ${({theme}) => theme["line"]};

  &::-webkit-scrollbar {
    width: 5px;
  }

  &::-webkit-scrollbar-thumb {
    border-radius: 5px;
    background: ${({theme}) =>
      theme["isDark"] ? "rgba(255, 255, 255, .2)" : "rgba(0, 0, 0, .2)"};
  }
`;

export const NavItem = styled(Link)`
  cursor: pointer;
  padding: 0.8rem;
  border-radius: 0.5rem;
  text-decoration: none;
  transition: all ease 0.3s;

  &:hover {
    background-color: ${({theme}) => theme["hover"]};
  }
`;

export const Restricted = styled.div`
  cursor: pointer;
  padding: 0.8rem;
  border-radius: 0.5rem;
  text-decoration: none;
  transition: all ease 0.3s;

  &:hover {
    background-color: ${({theme}) => theme["hover"]};
  }
`;

export const Frame = styled.div`
  padding: 1px;
  width: auto;
  border-radius: 10px;
  align-items: center;
  justify-content: center;
  display: flex;
  border: 2px solid ${({theme}) => theme["primary"]};
`;
